export default __webpack_public_path__ + "static/media/preview.736d6cef.jpg";